// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.7
//   protoc               unknown
// source: qonto/registration/register/documents/firstparty/v1/get_document.proto

/* oxlint-disable */
import { ApiDocument } from "./document";

/** Request message for getting a document by ID */
export interface ApiGetDocumentRequest {
  /** The ID of the document to retrieve */
  readonly id: string;
}

/** Response message for getting a document */
export interface ApiGetDocumentResponse {
  /** The requested document */
  readonly document: ApiDocument | null;
}

/** Error codes for GetDocument operation */
export interface ApiGetDocumentErrors {
}

/** Not found error codes */
export const ApiGetDocumentErrorsNotFoundError = {
  /** NOT_FOUND_ERROR_UNSPECIFIED - Unspecified not found error */
  NOT_FOUND_ERROR_UNSPECIFIED: "NOT_FOUND_ERROR_UNSPECIFIED",
  /** NOT_FOUND_ERROR_NOT_FOUND_OR_UNAUTHORIZED - Document not found or unauthorized */
  NOT_FOUND_ERROR_NOT_FOUND_OR_UNAUTHORIZED: "NOT_FOUND_ERROR_NOT_FOUND_OR_UNAUTHORIZED",
} as const;

export type ApiGetDocumentErrorsNotFoundError =
  typeof ApiGetDocumentErrorsNotFoundError[keyof typeof ApiGetDocumentErrorsNotFoundError];

export namespace ApiGetDocumentErrorsNotFoundError {
  export type NOT_FOUND_ERROR_UNSPECIFIED = typeof ApiGetDocumentErrorsNotFoundError.NOT_FOUND_ERROR_UNSPECIFIED;
  export type NOT_FOUND_ERROR_NOT_FOUND_OR_UNAUTHORIZED =
    typeof ApiGetDocumentErrorsNotFoundError.NOT_FOUND_ERROR_NOT_FOUND_OR_UNAUTHORIZED;
}

export function apiGetDocumentErrorsNotFoundErrorFromJSON(object: any): ApiGetDocumentErrorsNotFoundError {
  switch (object) {
    case 0:
    case "NOT_FOUND_ERROR_UNSPECIFIED":
      return ApiGetDocumentErrorsNotFoundError.NOT_FOUND_ERROR_UNSPECIFIED;
    case 1:
    case "NOT_FOUND_ERROR_NOT_FOUND_OR_UNAUTHORIZED":
      return ApiGetDocumentErrorsNotFoundError.NOT_FOUND_ERROR_NOT_FOUND_OR_UNAUTHORIZED;
    default:
      return ApiGetDocumentErrorsNotFoundError.NOT_FOUND_ERROR_UNSPECIFIED;
  }
}

export function apiGetDocumentErrorsNotFoundErrorToJSON(object: ApiGetDocumentErrorsNotFoundError): string {
  switch (object) {
    case ApiGetDocumentErrorsNotFoundError.NOT_FOUND_ERROR_UNSPECIFIED:
      return "NOT_FOUND_ERROR_UNSPECIFIED";
    case ApiGetDocumentErrorsNotFoundError.NOT_FOUND_ERROR_NOT_FOUND_OR_UNAUTHORIZED:
      return "NOT_FOUND_ERROR_NOT_FOUND_OR_UNAUTHORIZED";
    default:
      return "NOT_FOUND_ERROR_UNSPECIFIED";
  }
}

export const ApiGetDocumentRequest: MessageFns<ApiGetDocumentRequest> = {
  fromJSON(object: any): ApiGetDocumentRequest {
    return { id: isSet(object.id) ? globalThis.String(object.id) : "" };
  },

  toJSON(message: ApiGetDocumentRequest): unknown {
    const obj: any = {};
    if (message.id !== undefined && message.id !== null) {
      obj.id = message.id;
    }
    return obj;
  },
};

export const ApiGetDocumentResponse: MessageFns<ApiGetDocumentResponse> = {
  fromJSON(object: any): ApiGetDocumentResponse {
    return { document: isSet(object.document) ? ApiDocument.fromJSON(object.document) : null };
  },

  toJSON(message: ApiGetDocumentResponse): unknown {
    const obj: any = {};
    if (message.document !== undefined && message.document !== null) {
      obj.document = ApiDocument.toJSON(message.document);
    }
    return obj;
  },
};

export const ApiGetDocumentErrors: MessageFns<ApiGetDocumentErrors> = {
  fromJSON(_: any): ApiGetDocumentErrors {
    return {};
  },

  toJSON(_: ApiGetDocumentErrors): unknown {
    const obj: any = {};
    return obj;
  },
};

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

interface MessageFns<T> {
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
}
